var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as qs from 'qs';
import Axios from 'axios';
function handleSuccess(response) {
    return response.data;
}
/**
 * 异常处理函数
 * @param error
 */
function handleError(error) {
    const { response, message } = error;
    let errorMsg = '';
    if (response) {
        switch (response.status) {
            case 400:
                errorMsg = response.data ? response.data.message : '';
                break;
            case 500:
            case 501:
            case 502:
                errorMsg = response.data ? response.data.message : '服务器内部错误';
                break;
        }
        return Promise.reject({
            code: response.status,
            success: false,
            data: null,
            message: errorMsg,
        });
    }
    else if (message === 'cancel') {
        return Promise.reject({
            code: 50000,
            success: false,
            message: '',
        });
    }
    else {
        return Promise.reject({
            code: 50000,
            success: false,
            message: '对不起，服务出错了',
        });
    }
}
function createFlag(config) {
    const { baseURL = '', url = '', method = '', data, params } = config;
    let flag = baseURL + url + '&' + method;
    if (data) {
        flag += `&${data}`;
    }
    if (params) {
        flag += `&${JSON.stringify(params)}`;
    }
    return flag;
}
function removePending(config) {
    for (const p in pendingArr) {
        if (pendingArr.hasOwnProperty(p)) {
            const pending = pendingArr[p];
            if (pending.url === createFlag(config)) {
                pending.cancelFn('cancel');
                pendingArr.splice(+p, 1);
            }
        }
    }
}
let pendingArr = [];
const CancelToken = Axios.CancelToken;
const axios = Axios.create({
    baseURL: '/',
    // 查询对象序列化函数
    paramsSerializer(params) {
        return qs.stringify(params);
    },
    // 请求后的数据处理
    transformResponse: [
        function (data) {
            return data;
        },
    ],
    responseType: 'json',
    // xsrf 设置
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
});
axios.interceptors.request.use(config => {
    removePending(config);
    config.cancelToken = new CancelToken(cancelFn => {
        pendingArr.push({
            url: createFlag(config),
            cancelFn,
        });
    });
    return config;
}, err => {
    return Promise.reject(err);
});
axios.interceptors.response.use(response => {
    removePending(response.config);
    return response;
}, err => {
    pendingArr = [];
    return Promise.reject(err);
});
function post(url, data, option) {
    return axios
        .post(url, data, option)
        .then(handleSuccess)
        .catch(handleError);
}
export default {
    get: function (url, data, needLogin = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (needLogin && window.requestConfig.getToken) {
                const token = yield window.requestConfig.getToken();
                return axios
                    .get(url, {
                    headers: {
                        'access-token': token,
                    },
                    withCredentials: false,
                    params: data,
                })
                    .then(handleSuccess)
                    .catch(handleError);
            }
            return axios
                .get(url, {
                params: data,
                withCredentials: window.requestConfig
                    ? window.requestConfig.withCredentials
                    : false,
            })
                .then(handleSuccess)
                .catch(handleError);
        });
    },
    put: function (url, data, needLogin = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (needLogin && window.requestConfig.getToken) {
                const token = yield window.requestConfig.getToken();
                return axios
                    .put(url, data, {
                    headers: {
                        'access-token': token,
                    },
                    withCredentials: false,
                })
                    .then(handleSuccess)
                    .catch(handleError);
            }
            return axios
                .put(url, data, {
                withCredentials: window.requestConfig
                    ? window.requestConfig.withCredentials
                    : false,
            })
                .then(handleSuccess)
                .catch(handleError);
        });
    },
    delete: function (url, data, needLogin = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (needLogin && window.requestConfig.getToken) {
                const token = yield window.requestConfig.getToken();
                return axios
                    .delete(url, {
                    headers: {
                        'access-token': token,
                    },
                    withCredentials: false,
                    params: data,
                })
                    .then(handleSuccess)
                    .catch(handleError);
            }
            return axios
                .delete(url, {
                params: data,
                withCredentials: window.requestConfig
                    ? window.requestConfig.withCredentials
                    : false,
            })
                .then(handleSuccess)
                .catch(handleError);
        });
    },
    postForm: function (url, data, params, needLogin = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (needLogin && window.requestConfig.getToken) {
                const token = yield window.requestConfig.getToken();
                return post(url, qs.stringify(data || {}), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'access-token': token,
                    },
                    withCredentials: false,
                    params,
                });
            }
            return post(url, qs.stringify(data || {}), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                params,
                withCredentials: window.requestConfig
                    ? window.requestConfig.withCredentials
                    : false,
            });
        });
    },
    postJSON: function (url, data, params, needLogin = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (needLogin && window.requestConfig.getToken) {
                const token = yield window.requestConfig.getToken();
                return post(url, data, {
                    headers: {
                        'Content-Type': 'application/json',
                        'access-token': token,
                    },
                    params,
                    withCredentials: false,
                });
            }
            return post(url, data, {
                headers: {
                    'Content-Type': 'application/json',
                },
                params,
                withCredentials: window.requestConfig
                    ? window.requestConfig.withCredentials
                    : false,
            });
        });
    },
    postFile: function (url, data, params) {
        return __awaiter(this, void 0, void 0, function* () {
            return post(url, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                params,
                withCredentials: window.requestConfig
                    ? window.requestConfig.withCredentials
                    : false,
            });
        });
    },
    authGet: function (url, data) {
        return axios
            .get(url, { params: data })
            .then(handleSuccess)
            .catch(handleError);
    },
    authForm: function (url, data) {
        return axios
            .post(url, qs.stringify(data || {}), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
            .then(handleSuccess)
            .catch(handleError);
    },
};
